import React from 'react';
import PropTypes from 'prop-types';

import { getModuleLineNumbersFromProject } from '../../../utils/utilities';
import { getAffirmativeOptions } from '../../../utils/data';

import Joi from 'joi';
import Form from '../../common/form';

import toastService from '../../../services/toastService';
import withProjectDetails from '../../hoc/withProjectDetails';

class CustomUTMSummaryOverviewForm extends Form {
	state: any = {
		data: { hasAnomalies: '', lineNumber: '', overview: '' },
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
		hasAnomalies: Joi.string().min(2).required().label('Has Anomalies'),
        lineNumber: Joi.object({
			id: Joi.string().required(),
			name: Joi.string().required(),
			label: Joi.string().required(),
			value: Joi.string().required(),
			__isNew__: Joi.boolean().optional(),
		})
			.required()
			.label('Line Number'),
        overview: Joi.string().min(10).required().label('Overview'),
	};

    static propTypes = {
		initialSummary: PropTypes.object,
        onSave: PropTypes.func
    }

    componentDidMount() {
		if (this.props.initialSummary) {
			const initialData = { 
				hasAnomalies: this.props.initialSummary.hasAnomalies,
				overview: this.props.initialSummary.overview,
				lineNumber: this.createNewMultiSelectOption(this.props.initialSummary.lineNumber)
			};

			this.setState({ data: initialData });
		}
    }

    createNewMultiSelectOption = (lineNumber: string) => {
		return { id: lineNumber, name: lineNumber, label: lineNumber, value: lineNumber };
	};

	getLineNumberOptions = () => {
		if (this.props.projectDetails) {
			return getModuleLineNumbersFromProject(this.props.projectDetails).map(this.createNewMultiSelectOption);
		}
		
		return [];
	};

	handleNewOptionCreation = (newLineNumber: string) => {
		const newLineNumberOption = this.createNewMultiSelectOption(newLineNumber);
		const data = {...this.state.data, lineNumber: newLineNumberOption };

		this.setState({ data });
	};

	doSubmit = (): void => {
		this.props.onSave({
			hasAnomalies: this.state.data.hasAnomalies,
			lineNumber: (this.state.data.lineNumber as any).id,
            overview: this.state.data.overview,
		});

		toastService.success('Saved successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
                <div className="container">
					{this.renderSelect({
						options: getAffirmativeOptions(),
						name: 'hasAnomalies',
						label: 'Has Anomalies',
						placeholder: 'Select Has Anomalies',
					})}

					<div className="my-4 divider"></div>
					
                    <div className="row">
						<div className="col">
							{this.renderCreatableMultiselect({
								closeMenuOnSelect: true,
								options: this.getLineNumberOptions(),
								name: 'lineNumber',
								placeholder: 'Enter Line Number',
								label: 'Line Number',
								isMulti: false,
								onCreateOption: this.handleNewOptionCreation
							})}
						</div>

                        <div className="col-6">
                            {this.renderTextEditor({
                                name: 'overview',
                                label: 'Overview',
                                placeholder: 'Enter Overview',
                            })}
                        </div>
                    </div>
					
					<div className="d-flex justify-content-end">
						{this.renderButton('Save')}
					</div>
                </div>
			</form>
		);
	}
}

export default withProjectDetails(CustomUTMSummaryOverviewForm);
